// extracted by mini-css-extract-plugin
export default {"ThemeToggle":"ThemeToggle_ThemeToggle__s-5X5"};